import React from 'react';
import FormCard from '../components/FormCard/FormCard';
import { Form, Button, Row, Col } from 'react-bootstrap';
import UploadImage from '../../client/components/ImageUpload';
import {useSelector} from 'react-redux';
import Select from 'react-select';
import { useState, useEffect } from 'react';
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom';
import PopUpModal from '../../client/components/PopupModal';
import { Alert } from '@mui/material';

const EditeStoreProducts = () => {
    const {user} = useSelector((state)=> state.auth);
    const [stores, setStores] = useState();
    const [storeOptions, setStoreOptions] = useState();
    const [category, setCategory] = useState();
    const [categoryOptions, setCategoryOptions] = useState();
    const [name, setName] = useState('');
    const [quantity, setQuantity] = useState();
    const [costPrice, setCostPrice] = useState();
    const [salePrice, setSalePrice] = useState();
    const [discountedPrice, setDiscountedPrice] = useState();
    const [detail, setDetails] = useState('');
    const [file, setFile] = useState(null);
    const getFile = (f)=> {
        setFile(f);
    }
    const userId = user.seller_profile_id;
    const [modal, setModal] = useState(false);
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const params = useParams();
    const productId = params.id;
    const PF = process.env.REACT_APP_FIND_API_URL + "/images/";

    useEffect(()=> {
        axios.post(process.env.REACT_APP_FIND_API_URL + `/store-products/edit-store-product/${productId}`,{}, {withCredentials: true}).then((res)=> {
            const data = res.data.data.data[0];
            setStores({value: data.seller_shop_id, label: data.seller_store_name})
            setCategory({value: data.category_id, label: data.category_name})
            setName(data.name);
            setQuantity(data.quantity);
            setSalePrice(data.price)
            setCostPrice(data.cost_price)
            setDiscountedPrice(data.discounted_price)
            setDetails(data.details)
            setFile(data.images)
        })
    }, [productId])

    useEffect(()=> {
        const getStores = async(id)=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/store/get-store/${id}`, {withCredentials: true}).then((res)=> {
                const getData = res.data.map((d)=> ({value: d.seller_shop_id, label: d.seller_store_name}))
                setStoreOptions(getData)
            })
        }
        if(userId) {
            getStores(userId)
        }
    }, [userId])

    useEffect(()=> {
        const getCategory = async()=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/category/get-store`, {withCredentials: true}).then((res)=> {
                const getData = res.data.data.map((d)=> ({value: d.category_id, label: d.category_name}))
                setCategoryOptions(getData)
            })
        }
        getCategory()
    }, []);

    const handleSubmit = async(e)=> {
        e.preventDefault();
            const newProduct = {
                shop_id: stores.value,
                category_id: category.value,
                name: name,
                quantity: quantity,
                cost_price: costPrice,
                price: salePrice,
                discounted_price: discountedPrice,
                details: detail
            }
            if(file) {
                const data = new FormData();
                const filename = Date.now() + file.name;
                data.append("name", filename);
                data.append("file", file);
                newProduct.images = filename;
                try {
                await axios.post(process.env.REACT_APP_FIND_API_URL + "/upload", data, {withCredentials: true});
                } catch (error) {
                console.log(error);
                }
            }
        try {
            const res = await axios.patch(process.env.REACT_APP_FIND_API_URL + `/store-products/update-store-product/${productId}`, newProduct, {withCredentials: true});
            if(res.data) {
                setTimeout(()=> setModal(false), 1000);
                setTimeout(()=> navigate('/admin/dashboard'), 1000)
            }
        } catch (error) {
            setError(error)
        }
    }


    return (
        <FormCard title="Add Products">
            {<PopUpModal title="Product Added Successfully." show={modal} onHide={() => setModal(false)} />}
            {error && <Alert severity="error">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Shop</Form.Label>
                            <Select placeholder="Select Store" options={storeOptions} onChange={(e)=> setStores(e)} value={stores}/>
                        </Form.Group>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Select Category</Form.Label>
                            <Select placeholder="Select Category" options={categoryOptions} onChange={(e)=> setCategory(e)} value={category}/>
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter Product Name" value={name} onChange={(e)=> setName(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control type="number" placeholder="Enter Quantity" value={quantity} onChange={(e)=> setQuantity(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Cost Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Cost Price" value={costPrice} onChange={(e)=> setCostPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Sale Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Sale Price" value={salePrice} onChange={(e)=> setSalePrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3">
                            <Form.Label>Discounted Price</Form.Label>
                            <Form.Control type="number" placeholder="Enter Discounted Price" value={discountedPrice} onChange={(e)=> setDiscountedPrice(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Product Details</Form.Label>
                            <Form.Control as="textarea" placeholder='Enter Product Details...' rows={3} value={detail} onChange={(e)=> setDetails(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        { file &&
                            <div>
                                <img className='rounded' width="130px" height="130" src={PF + file} alt={file} />
                            </div>
                        }
                        <UploadImage title="logo" getFile={getFile} />
                    </Col>
                </Row>
                <div>
                    <Button variant="primary" type="submit" className="w-100">
                        Submit
                    </Button>
                </div>
            </Form>
        </FormCard>
    )
}

export default EditeStoreProducts;